var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on-time (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6503 31.9984C18.7889 32.15 17.9035 32.2293 16.9997 32.2293C8.59459 32.2293 1.77051 25.4052 1.77051 17.0002C1.77051 8.59508 8.59459 1.771 16.9997 1.771C25.4048 1.771 32.2288 8.59508 32.2288 17.0002C32.2288 17.904 32.1495 18.7894 31.9979 19.6507C30.3914 17.4039 27.7621 15.9377 24.7913 15.9377C19.9053 15.9377 15.9372 19.9057 15.9372 24.7918C15.9372 27.7626 17.4034 30.3919 19.6503 31.9984ZM18.7705 9.2085V16.2918C18.7705 16.5737 18.6586 16.8443 18.4588 17.0427L12.7922 22.7093C12.3785 23.1244 11.7042 23.1244 11.2905 22.7093C10.8754 22.2957 10.8754 21.6213 11.2905 21.2077L16.6455 15.8512V9.2085C16.6455 8.622 17.1215 8.146 17.708 8.146C18.2945 8.146 18.7705 8.622 18.7705 9.2085Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.791 17.3545C20.6855 17.3545 17.3535 20.6865 17.3535 24.792C17.3535 28.8975 20.6855 32.2295 24.791 32.2295C28.8965 32.2295 32.2285 28.8975 32.2285 24.792C32.2285 20.6865 28.8965 17.3545 24.791 17.3545ZM21.2068 25.1887L23.3318 27.3137C23.7469 27.7287 24.4184 27.7287 24.8335 27.3137L28.3752 23.772C28.7903 23.3583 28.7903 22.684 28.3752 22.2703C27.9615 21.8552 27.2872 21.8552 26.8735 22.2703L24.0827 25.0597L22.7085 23.687C22.2948 23.2719 21.6205 23.2719 21.2068 23.687C20.7918 24.1007 20.7918 24.775 21.2068 25.1887Z",
    fill: "#00FFF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.932c8fcfb260e7b3814ece317b67a9e4.svg";
export { ForwardRef as ReactComponent };